import React from 'react';
import '../../graphStyles.scss';
import { GraphDropDown } from '../../GraphDropDown';
import NoDataFound from "../../../NoDataFound";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  Filler,
  BarController
);

export function VisitorsNumbersByTermGraph({ display, weeks, visitors, percentOfBooking, nameLabels, totalSales }) {
  const [currentWeek, setCurrentWeek] = React.useState(0);

  // Debug logging
  console.log("🎯 UTM Term Graph: Received props:", {
    weeks: weeks?.length || 0,
    visitors: visitors?.length || 0,
    percentOfBooking: percentOfBooking?.length || 0,
    nameLabels: nameLabels?.length || 0,
    totalSales: totalSales?.length || 0,
    currentWeek,
    weeksData: weeks,
    visitorsData: visitors
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        onHover: function(event, legendItem) {
          document.getElementById("chart10").style.cursor = 'pointer';
        },
        onLeave: function(event, legendItem) {
          document.getElementById("chart10").style.cursor = 'default';
        },
        labels: {
          filter: (l) => (l.text !== 'none'),
          boxWidth: 10,
          padding: 10,
        },
      }
    },
    scales: {
      x: {
        title: {
          text: "UTM term category",
          display: true,
          font: {
            size: 13.5
          }
        },
        grid: {
          display: false
        },
        ticks: {
          maxRotation: 40,
          minRotation: 20,
          font: {
            size: 10
          }
        }
      },
      y: {
        position: 'left',
        title: {
          text: "Number of visitors",
          display: true,
          font: {
            size: 13.5
          }
        }
      },
      y1: {
        position: 'right',
        title: {
          text: "% of visitors",
          display: true,
          font: {
            size: 13.5
          }
        }
      }
    }
  };

  const labels = nameLabels && nameLabels[currentWeek] ? nameLabels[currentWeek] : [];

  const data = {
    labels,
    datasets: [
      {
        label: '% of visitors booking in this cohort',
        data: percentOfBooking && percentOfBooking[currentWeek] ? percentOfBooking[currentWeek] : [],
        yAxisID: 'y1',
        borderColor: 'rgba(250, 210, 90, 0.99)',
        backgroundColor: 'rgba(250, 210, 90, 0.99)',
        hoverBackgroundColor: 'rgba(250, 210, 90, 0.99)',
        order: 0,
        type: 'line',
        pointRadius: 3,
        lineTension: 0.4
      },
      {
        label: 'Number of visitors',
        data: visitors && visitors[currentWeek] ? visitors[currentWeek] : [],
        backgroundColor: 'rgba(12, 200, 255, 0.99)',
        hoverBackgroundColor: 'rgba(12, 200, 255, 0.99)',
        yAxisID: 'y',
        order: 0,
      },
      {
        label: (totalSales && totalSales[currentWeek] !== undefined && totalSales[currentWeek].length !== 1) ? '% of Total Sales' : 'none',
        data: totalSales && totalSales[currentWeek] ? totalSales[currentWeek] : [],
        yAxisID: 'y1',
        type: 'line',
        lineTension: 0.4,
        borderColor: (totalSales && totalSales[currentWeek] !== undefined && totalSales[currentWeek].length !== 1) ? 'rgba(255,120,0,1)' : 'rgba(0,0,0,0)',
        backgroundColor: (totalSales && totalSales[currentWeek] !== undefined && totalSales[currentWeek].length !== 1) ? 'rgba(255,120,0,1)' : 'rgba(0,0,0,0)',
        hoverBackgroundColor: (totalSales && totalSales[currentWeek] !== undefined && totalSales[currentWeek].length !== 1) ? 'rgba(255,120,0,1)' : 'rgba(0,0,0,0)',
      }
    ],
  };

  return (
    <div className='graph'>
      <div className='graph__title flex flex-col md:flex-row justify-between items-center'>
        <h4 className='text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0'>
        Number of visitors through UTM term category
        </h4>
        <GraphDropDown
          display={display}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
          weeks={weeks}
          className='w-full md:w-auto'
        />
      </div>
      {(!weeks || weeks.length === 0) ? (
        <NoDataFound />
      ) : (
        <div className='relative w-full' style={{ height: '300px' }}>
          <Chart
            className='chart'
            id='chart10'
            type='bar'
            options={options}
            data={data}
          />
        </div>
      )}
    </div>
  );
}
